module.exports = __webpack_public_path__ + "media/images/icons/btn-arrow-3a7c05affab9bd9dd27bfc7e3971a94a.svg";